module.exports = __webpack_public_path__ + "img/w-next_task.6edea2b0.svg";